import * as types from './action-types';

import RelocationApi from '../../../api/RelocationApi';

// vehicles
export const fetchingVehicles = () => ({
  type: types.FETCHING_VEHICLES,
});

//Cant move to the redux-middleware-promise since it has additonal intermediate state like ADD_MORE_VEHICLES_SUCCESS which doesnt fit into PENDING, FULFILLED ERROR scheme of things.- TODO sriram
export const fetchVehiclesSuccess = (data, getMore) => {
  return getMore
    ? {
        type: types.ADD_MORE_VEHICLES_SUCCESS,
        data,
      }
    : {
        type: types.FETCH_VEHICLES_SUCCESS,
        data,
      };
};
export const fetchVehicles = (params, getMore = false) => {
  return dispatch => {
    dispatch(fetchingVehicles());
    return RelocationApi.getVehicles(params)
      .then(({ data }) => dispatch(fetchVehiclesSuccess(data, getMore)))
      .catch();
  };
};

//Fetch the vehicle details
export const fetchVehicleDetails = params => ({
  type: types.FETCH_VEHICLE_DETAILS,
  payload: RelocationApi.getVehicleDetails(params),
});

export const fetchVehicleCostCenter = (
  country,
  companyCode,
  lookup,
  offset,
  limit
) => ({
  type: types.FETCH_VEHICLE_COSTCENTERLIST,
  payload: RelocationApi.getAvailableCostCenter(
    country,
    companyCode,
    lookup,
    offset,
    limit
  ),
});

export const changeCostcenter = (country, data) => {
  return dispatch => {
    return RelocationApi.changeVehicleCostcenter(country, data);
  };
};



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/actions.js